import { ExternalResourcesAction, ExternalResourcesActionKeys } from '../actions/externalResources';
import { UiAction, UiActionKeys } from '../actions/ui';

export interface ExternalResourceData {
	css: string;
	scripts?: string;
	themesCss?: string;
}

interface ResourceState extends ExternalResourceData {
	isLoading: boolean;
}

export interface ExternalResourcesState {
	[k: number]: ResourceState;
}

const externalResourcesInitialState: ExternalResourcesState = {};

export const externalResources = (state: ExternalResourcesState = externalResourcesInitialState, action: ExternalResourcesAction | UiAction): ExternalResourcesState => {
	switch (action.type) {
		case ExternalResourcesActionKeys.GET_DATA:
			return {
				...state,
				[action.id]: {
					...state[action.id],
					isLoading: true,
				},
			};
		case ExternalResourcesActionKeys.SET_DATA:
			return {
				...state,
				[action.id]: {
					...state[action.id],
					...action.data,
					isLoading: false,
				},
			};
		case ExternalResourcesActionKeys.RESET_LOADING:
			return {
				...state,
				[action.id]: {
					...state[action.id],
					isLoading: false,
				},
			};
		case UiActionKeys.RESET:
			return externalResourcesInitialState;
		default:
			return state;
	}
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/reducer/externalResources.ts